import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {hideProductLegend, showProductLegend} from '../../actionCreators';

const Label = gettext('More information');

const Toggle = ({onClick}) => (
    <div className="mobile-only legend-toggle" onClick={onClick}>
        <i className="icon icon-help" title={Label} />
    </div>
);

const mapDispatchToProps = (dispatch, {show}) => ({
    onClick: () => dispatch(show ? hideProductLegend : showProductLegend),
});

export default connect(undefined, mapDispatchToProps)(Toggle);
